// removed by extract-text-webpack-plugin
module.exports = {"image-container":"src-components-Admin-newsGrid-singleStory-___singleStory__image-container___3lSRJ","text-container":"src-components-Admin-newsGrid-singleStory-___singleStory__text-container___303Ms","button-container":"src-components-Admin-newsGrid-singleStory-___singleStory__button-container___Xb3Ai","container":"src-components-Admin-newsGrid-singleStory-___singleStory__container___37wVo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Admin/newsGrid/singleStory/singleStory.css
// module id = 1050
// module chunks = 0